import React,{ useState, useEffect } from "react";
import { 
    Button,
    Form,
    Input,
} from 'antd';

import axios from 'axios';

import { 
    MinusCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

function QualificationFormStandalone({
    setQualificationAddress,
    setQualificationAddressUnit,
    qualificationAddressStatus,
    setQualificationAddressStatus
}) {

    const [addressSuggestionList, setAddressSuggestionList] = useState(<></>);
    //const [qualificationAddress, setQualificationAddress] = useState(null);
    //const [qualificationAddressUnit, setQualificationAddressUnit] = useState('');
    const [addressesQualifying, setAddressQualifying] = useState( false );
    const [magicKey, setMagicKey] = useState( '' );
    const [addressDetails, setAddressDetails] = useState( null );
    const [addressValidSuffix, setAddressValidSuffix] = useState(<></>);
    const [unitValidSuffix, setUnitValidSuffix] = useState(<></>);
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let form_data = new FormData;
        form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

        if( currentVal.length < 3 ) {
            setAddressValidSuffix(<CloseCircleOutlined style={{ color: '#ff4545' }}/>);
            setQualificationAddressStatus('');
        } else {
            setAddressValidSuffix(<CheckCircleOutlined style={{ color: '#52C41A' }}/>);
        }

        if( currentVal.length > 6 ) {
            axios
            .get(headerVars.startAPIAddress+"/address/validate_telus?fullAddress="+currentVal+"&excludeUnits=1", {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                let suggestions = response.data.body.suggestions;
                let source = response.data.body.source;
                //console.log('suggestions: ', suggestions);

                if(suggestions.length){
                    listAddressSugestions(source, suggestions, 'qualification'); 
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const listAddressSugestions = ( source, suggestions, lookupType ) => {
        let suggestionListItems = suggestions.map( suggestion => {
            let suggestionText = suggestion.text.replace(', CAN', '');
            return(
                <li id={suggestion.magicKey} className='address-suggestion-item' onClick={( e ) => handleSuggestionClick( e, source, suggestionText, lookupType ) }>
                    { suggestionText + ". " }
                </li>
            );
        } );

        setAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
    }

    const handleSuggestionClick = ( e, source, suggestionText, lookupType ) => {
        //console.log("suggestionText:: ", suggestionText);
        setAddressSuggestionList(<></>);
        setMagicKey( e.target.id );
        form.setFieldsValue({ "qualification-address": suggestionText});
        getAddressDetails( e.target.id, suggestionText, source );

        setAddressValidSuffix(<CheckCircleOutlined style={{ color: '#52C41A' }}/>);
    }

    const handleOnAddressUnitChange = ( e ) =>{
        let currentVal = e.target.value;
        let inputID = e.target.id;

        setQualificationAddressUnit( currentVal );

        if( currentVal.length == 0 ) {
            setUnitValidSuffix(<CloseCircleOutlined style={{ color: '#ff4545' }}/>);
        } else {
            setUnitValidSuffix(<CheckCircleOutlined style={{ color: '#52C41A' }}/>);
        }
    }

    function getAddressDetails( selectedID, addressInput, source ) {
        //console.log("selectedID:: ", selectedID);
        //console.log("addressInput:: ", addressInput);
        //console.log("source:: ", source);

        if( selectedID != '' ) {
            let form_data = new FormData;
            form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

            axios
            .get(headerVars.startAPIAddress+"/address/details_telus?magicKey="+selectedID+"&text="+addressInput+"&source="+source, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                setQualificationAddress( addressInput );
                //console.log("address details response:: ", response.data);
                if(response.data.body.candidates.length){ 
                    setAddressDetails( response.data.body.candidates );
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const handleConfirmChangeQualificationAddress = () =>{
        setAddressQualifying( true );

        var postal1 = addressDetails[0].attributes.Postal;
        var postal2 = addressDetails[0].attributes.PostalExt;
        var strName = addressDetails[0].attributes.StName;
        var strNumber = addressDetails[0].attributes.AddNum;
        var strType = addressDetails[0].attributes.StType;
        var strDir = addressDetails[0].attributes.StDir;
        var addressLngLabel = addressDetails[0].attributes.Match_addr;
        var city = addressDetails[0].attributes.City;
        var prov = addressDetails[0].attributes.RegionAbbr;
        var prettyPostal = postal1 + " " + postal2;

        console.log('addressDetails: ', addressDetails);
        console.log('addressLngLabel: ', addressLngLabel);

        strType = strType.replace(/\s/g, '');
        strDir = strDir.replace(/\s/g, '');

        if( strType == "" ) {
            strType = "NA";
        }

        axios
        .get(headerVars.startAPIAddress+"/address/qualify/product?PostalCode="+postal1+postal2+"&StreetName="+strName+"&StreetNumber="+strNumber+"&StreetType="+strType+"&UnitNumber="+qualificationAddressUnit+"&StreetDirection="+strDir, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
        .then(function(response){
            setAddressQualifying( false );
            let qualificationObject = response.data;
            console.log('qualificationObject: ', qualificationObject);

            var isD2C = localStorage.getItem('is-d2c-session');

            var productAry = [];

            var scrollDiv = document.getElementById("react-qualification-form-container").offsetTop;
            console.log('scrollDiv:: ', scrollDiv);
            window.scrollTo({ top: scrollDiv, behavior: 'smooth'});

            if( response.data.body.Products ) {
                for( var i=0; i < response.data.body.Products.length; i++ ) {
                    if( response.data.body.Products[i].Service == "Fibre" ) {
                        productAry.push({
                            "service": {
                                "speed": "",
                                "service_id": response.data.body.Products[i].SKU,
                                "action": response.data.body.Products[i].Action,
                                "provider": response.data.body.Products[i].Service,
                                "self_install": response.data.body.Products[i].SelfInstall,
                            }
                        });
                    }
                }
            }

            var rogersPortalActive = null;
            if( response.data.body.RogersActive ) {
                rogersPortalActive = response.data.body.RogersActive;
            }

            var altimaPortalActive = null;
            if( response.data.body.AltimaActive ) {
                altimaPortalActive = response.data.body.AltimaActive;
            }

            var unitNumberStr = "";

            if( qualificationAddressUnit != "" ) {
                unitNumberStr = " Unit "+ qualificationAddressUnit;
            }

            var serviceObj = {
                "address": { 
                    "street_number": strNumber,
                    "street_name": strName,
                    "street_type": strType,
                    "street_dir": strDir,
                    "address_string": addressLngLabel + unitNumberStr,
                    "postal": postal1+postal2,
                    "city": city,
                    "province": prov,
                    "unit": qualificationAddressUnit,
                    "latitude": "",
                    "longitude": "",
                },
                "services":productAry,
                "is_d2c":isD2C,
                "rogers_portal_active":rogersPortalActive,
                "altima_portal_active":altimaPortalActive
            };

            var qualifiedAddressDataObj = serviceObj;
            var qualifiedAddressDataObjJSON = JSON.stringify(serviceObj);
            var availableServices = qualifiedAddressDataObj.services;

            handleHubspotSubmission( addressLngLabel, qualificationAddressUnit, prettyPostal, strName, city, strNumber, strType, strDir, prov);

            if( availableServices[ 0 ].service.provider == 'Fibre' ) {
                jQuery("#qualificationData").val(qualifiedAddressDataObjJSON);
                document.dispatchEvent(new CustomEvent('cartInternetProductsUpdateState', { detail: '' }));
            } else {
                let formAction = window.location.href = 'https://www.koodomobile.com/on/shop/subscriptions/internet?cmp=prt_kd_sod_tar_ah_starttoki&lpdsid='+magicKey;
            }
        })
        .catch(function (error) {
            console.log(error);
            setAddressQualifying( false );
        })
        .finally(function () {
            // always executed 
        }); 
    }

    function handleHubspotSubmission( address, unit, postal, strName, city, strNumber, strType, strDir, prov ) {
        var timestamp = Date.now();
        var formID = '7b77f67f-44eb-43a8-b941-d18df2a1ed12';
        var data = {
            "submittedAt": timestamp,
            "fields": [
                {
                    "objectTypeId": "0-1",
                    "name": "address",
                    "value": address
                },
                {
                    "objectTypeId": "0-1",
                    "name": "unit",
                    "value": unit
                },
                {
                    "objectTypeId": "0-1",
                    "name": "postal",
                    "value": postal
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_name",
                    "value": strName
                },
                {
                    "objectTypeId": "0-1",
                    "name": "city",
                    "value": city
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_number",
                    "value": strNumber
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_type",
                    "value": strType
                },
                {
                    "objectTypeId": "0-1",
                    "name": "street_direction",
                    "value": strDir
                },
                {
                    "objectTypeId": "0-1",
                    "name": "province",
                    "value": prov
                }
            ],
            "context": {
                "hutk": hutk,
                "pageUri": "www.start.ca/",
                "pageName": "Start.ca"
            },
        }
        var hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        var form_data = JSON.stringify(data);
        var finalData = {
            "formData" : form_data,
            "formID" : formID
        };

        var path = headerVars.themeURI+"/inc/hubspot-tracking.php";

        jQuery.post(path, finalData)
        .done(function( hubspotPushSuccess ) {
            console.log("hubspotPushSuccess: ", hubspotPushSuccess);
        })
        .fail(function() {
            console.log("Hubspot data push failed");
        });
    }

    return (
        <div className="startca-react-qualification-form-container" id="react-qualification-form-container">
            <div className="qualification-form">
                <Form
                    form={ form }
                    style={{ position:'relative' }}
                >
                    <div className="form-column-row-inline">
                        <Form.Item
                            label="Service address"
                            name="qualification-address"
                            labelCol={{ span: 24 }}
                            //style={{marginBottom:'0', width:'100%'}}
                        >
                            <Input
                                id="qualification-address-input"
                                name="qualification-address-input"
                                onChange={handleOnInputChange}
                                suffix={ addressValidSuffix }
                                status={ qualificationAddressStatus }
                                //autoFocus
                                placeholder="Enter your street address"
                            />
                        </Form.Item>

                        <Form.Item
                            label="Apartment unit"
                            labelCol={{ span: 24 }}
                            name="qualification-address-unit-input"
                            style={{width:'30%', paddingLeft: '1rem'}}
                        >
                            <Input
                                id="qualification-address-unit-input"
                                name="qualification-address-unit-input"
                                onChange={handleOnAddressUnitChange}
                                placeholder="Unit"
                                suffix={ unitValidSuffix }
                            />
                        </Form.Item>
                    </div>
                    <div className="suggestion-list-container">
                        { addressSuggestionList }
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default QualificationFormStandalone